const recoveryKey = (bundleUrl: string) => `ark-vite-preload-recovery:${bundleUrl}`;

type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem'>;

export const recoverFromVitePreloadError = (
  event: Event,
  storage: RecoveryStorage,
  bundleUrl: string,
  reload: () => void,
): boolean => {
  const key = recoveryKey(bundleUrl);

  try {
    if (storage.getItem(key)) {
      return false;
    }
    storage.setItem(key, '1');
  } catch {
    return false;
  }

  event.preventDefault();
  reload();
  return true;
};

export const installVitePreloadRecovery = () => {
  let storage: Storage;
  try {
    storage = window.sessionStorage;
  } catch {
    return;
  }

  window.addEventListener('vite:preloadError', (event) => {
    recoverFromVitePreloadError(
      event,
      storage,
      import.meta.url,
      () => window.location.reload(),
    );
  });
};
